import type { FC } from "react";
import { useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { PremiumFeatureContactUsModal } from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureContactUsModal/PremiumFeatureContactUsModal";
import type { PremiumFeature } from "app/pages/sales-intelligence/pages/premium-features/types";
import { getPremiumFeaturesActions, getUserRole } from "app/pages/sales-intelligence/pages/premium-features/utils";

import { PremiumFeatureCard } from "../../components/PremiumFeatureCard/PremiumFeatureCard";

import {
    StyledFeaturesContainer,
    StyledFeaturesContainerWrapper,
    StyledFeaturesDescription,
    StyledFeaturesHeader,
} from "./styles";

interface AllFeaturesContainerProps {
    features: readonly PremiumFeature[];
}

export const AllFeaturesContainer: FC<AllFeaturesContainerProps> = ({ features }) => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);

    const handleContactUsClick = () => {
        setContactUsModal(true);
    };

    const userRole = getUserRole();

    return (
        <StyledFeaturesContainerWrapper>
            <StyledFeaturesHeader>{translate("si.premium-feature.block.all-features.title")}</StyledFeaturesHeader>
            <StyledFeaturesDescription>
                {translate("si.premium-feature.block.all-features.subtitle")}
            </StyledFeaturesDescription>

            <StyledFeaturesContainer>
                {features.map((item: PremiumFeature) => (
                    <PremiumFeatureCard
                        key={item.type}
                        {...item}
                        {...getPremiumFeaturesActions({
                            type: item.type,
                            role: userRole,
                            onCustomClick: handleContactUsClick,
                        })}
                    />
                ))}
            </StyledFeaturesContainer>
            <PremiumFeatureContactUsModal
                isOpen={contactUsModal}
                onClose={() => setContactUsModal(false)}
            />
        </StyledFeaturesContainerWrapper>
    );
};
